import React from 'react';
import { RangeSlider } from 'lib/components/range-slider/RangeSlider';
import { Flex } from 'lib/components/styles/layout';
import { FaMinus, FaPlus } from 'react-icons/fa6';
import { useTheme } from 'styled-components/macro';
import { IconWrapper } from './styles';

interface ISliderControlProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
}

export const SliderControl = ({
  value,
  onChange,
  min = 0,
  max = 100,
  step = 1,
}: ISliderControlProps) => {
  const theme = useTheme();

  const decreaseValue = (): void => {
    onChange(Number(value) - step);
  };
  const increaseValue = (): void => {
    onChange(Number(value) + step);
  };

  const isAtMin = value <= min;
  const isAtMax = value >= max;

  return (
    <Flex justifyContent={'center'} alignItems={'center'}>
      <Flex
        flexDirection='row'
        justifyContent={'space-between'}
        alignItems={'center'}
        gap='12px'
      >
        <IconWrapper onClick={decreaseValue} disabled={isAtMin}>
          <FaMinus size={'14px'} color={theme.colors.primary[100]} />
        </IconWrapper>
        <RangeSlider
          value={value}
          handleChange={onChange}
          min={min}
          max={max}
        />
        <IconWrapper onClick={increaseValue} disabled={isAtMax}>
          <FaPlus size={'14px'} color={theme.colors.primary[100]} />
        </IconWrapper>
      </Flex>
    </Flex>
  );
};
